import Image from "next/image";
import { ReactNode } from "react";

import closeIcon from "@/assets/icons/close-search.svg";

import styles from "./index.module.scss";

type Props = {
  title: string;
  showClose: boolean;
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  children: ReactNode;
  titleLarge?: boolean;
  titleRed?: boolean;
  titleBlue?: boolean;
  onClose?: () => void;
};

const Modal: React.FC<Props> = ({
  title,
  showClose,
  show,
  setShow,
  children,
  titleLarge,
  titleRed,
  titleBlue,
  onClose
}) => {
  return (
    <>
      {show && (
        <div
          className={styles.overlay}
          onClick={() => {
            if (showClose) {
              setShow(false);
              if (onClose) onClose();
            }
          }}
        >
          <div
            className={styles.container}
            onClick={(e) => e.stopPropagation()}
          >
            {title && (
              <div
                className={
                  titleRed
                    ? styles.title__red
                    : titleLarge
                      ? styles.title__large
                      : titleBlue
                        ? styles.title__blue
                        : styles.title
                }
              >
                {title}
              </div>
            )}
            {showClose && (
              <div
                className={styles.close}
                onClick={() => {
                  setShow(false);
                  if (onClose) onClose();
                }}
              >
                <Image src={closeIcon} alt="閉じる" />
              </div>
            )}
            {children}
          </div>
          {/* 背景をスクロールさせない(https://qiita.com/yowatsuyoengineer/items/b43b64e1419fa285b758) */}
          <div className="h-[calc(100vh+1px)] w-1 bg-transparent"></div>
        </div>
      )}
    </>
  );
};

export default Modal;
